<template>
  <div id="line"
    :style="`color: ${textColor};background: ${backgroundColor};height: ${getHeight()}`"
  >
    {{text}}
  </div>
</template>

<script>
  export default {
    name: "myLine",
    props:{
      text:{
        type:String,
        default:'',
      },
      textColor:{
        type:String,
        default:'#909399',
      },
      backgroundColor:{
        type:String,
        default:'#f5f7fa',
      },
    },
    methods:{
      getHeight() {
        if (this.text) {return '9.333vw'}
        else {return '2.133vw'}
      },
    },
  }
</script>

<style scoped>
  #line{
    font-size: 3.467vw;
    padding-left: 4vw;
    display: flex;
    align-items: center;
  }
</style>
